/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IVaccination } from 'app/shared/model/vaccination.model';
import { IVaccinationScheduleDetails } from 'app/shared/model/vaccination-schedule-details.model';

export interface IUserVaccinationScheduleDetails {
  id?: string;
  active?: boolean;
  dosage?: string | null;
  givenDate?: number | null;
  lastModifiedDt?: dayjs.Dayjs | null;
  microSec?: number;
  periodInDays?: number;
  recDateMax?: number;
  recDateMin?: number;
  risk?: string | null;
  timestampentry?: number;
  vaccinationTypeCd?: string | null;
  lastupdated?: number;
  completionStatus?: string;
  cursor?: number;
  batchNumber?: string | null;
  serialNumber?: string;
  glucoUser?: IGlucoUser;
  vaccination?: IVaccination;
  scheduleDetails?: IVaccinationScheduleDetails;
}

export const defaultValue: Readonly<IUserVaccinationScheduleDetails> = {
  active: false,
};
